import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './TypesTab';
import Form from './TypeForm';

function TypesRouter() {
  return (
    <Switch>
      <Route exact path="/types" component={Tab} />
      <Route exact path="/types/new" component={Form} />
      <Route exact path="/types/:id" component={Form} />
      <Redirect to="/types" />
    </Switch>
  );
}

export default TypesRouter;



// WEBPACK FOOTER //
// ./src/containers/Types/index.js